module.exports = __webpack_public_path__ + "static/media/Recriuitmant.e253f254.png";